import { formatDialect, snowflake } from 'sql-formatter';

export const safeSqlFormatter = (sql) => {
    try {
        return formatDialect(sql, { dialect: snowflake });
    } catch (e) {
        const shortMessage = e.message.substring(0, e.message.indexOf('\n'));

        console.warn('SQL Format Error:', shortMessage, sql);

        return null;
    }
};
